import { PAGE_TOUR_RESCHEDULE, PAGE_CONFIRMED } from '../constants/formSections';

export const getIsRescheduleFlow = () => {
    return window.location.href.includes(PAGE_TOUR_RESCHEDULE);
};

export const getIsConfirmationPage = () => {
    return window.location.href.includes(PAGE_CONFIRMED);
};

export const parseNewSchedulingLink = (basename, link) => {
    return basename.slice(0, -32).concat(link.split('/').find(itm => itm.length === 32));
};
